import * as Yup from 'yup'

const StatusData = Yup.object().shape({
  status: Yup.string().oneOf(['ok', 'error']).required(),
  message: Yup.string().nullable(),
})

export { StatusData }
